<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="$route.path"
            :collapse="collapse"
            background-color="#324157"
            text-color="#bfcbd9"
            active-text-color="#FDC911FF"
            unique-opened
            router
        >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu
                                v-if="subItem.subs"
                                :index="subItem.index"
                                :key="subItem.index"
                            >
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item
                                    v-for="(threeItem,i) in subItem.subs"
                                    :key="i"
                                    :index="threeItem.index"
                                >{{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                v-else
                                :index="subItem.index"
                                :key="subItem.index"
                            >{{ subItem.title }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../../../../js/bus'
export default {
  data () {
    return {
      collapse: false,
      items: [
        {
          icon: 'el-icon-pie-chart',
          index: '/back/dashboard',
          title: '统计看板'
        },
        {
          icon: 'el-icon-pie-chart',
          index: '1',
          title: '用户管理',
          subs: [
            {
              index: '/back/register_code_manage',
              title: '注册码管理'
            },
            {
              index: '/backmanage/user_manage',
              title: '用户列表'
            }

            // {
            //   index: '3-2',
            //   title: '三级菜单',
            //   subs: [
            //     {
            //       index: '/backmanage/editor',
            //       title: '富文本编辑器'
            //     },
            //     {
            //       index: 'markdown',
            //       title: 'markdown编辑器'
            //     }
            //   ]
            // },
            // {
            //   index: '/backmanage/upload',
            //   title: '文件上传'
            // }
          ]
        },
        {
          icon: 'el-icon-pie-chart',
          index: '2',
          title: '博客管理',
          subs: [
            {
              index: '/back/add_blog',
              title: '新建博客'
            },
            {
              index: '/back/blog_manage',
              title: '博客管理'
            },
            {
              index: '',
              title: '博客标签管理'
            }

          ]
        },
        {
          icon: 'el-icon-pie-chart',
          index: '/back/message_manage',
          title: '留言板管理'
        },
        {
          icon: 'el-icon-pie-chart',
          index: '3',
          title: '电影管理',
          subs: [
            {
              index: '/back/add_movie',
              title: '添加电影'
            },
            {
              index: '/back/movie_manage',
              title: '电影列表'
            }

          ]
        },
        {
          icon: 'el-icon-pie-chart',
          index: '4',
          title: '电视剧管理',
          subs: [
            {
              index: '/back/add_tvseries',
              title: '添加电视剧'
            },
            {
              index: '/back/tvseries_manage',
              title: '电视剧列表'
            }

          ]
        },
        {
          icon: 'el-icon-pie-chart',
          index: '5',
          title: '学习管理',
          subs: [
            {
              index: '/back/add_study',
              title: '添加学习资源'
            },
            {
              index: '/back/study_manage',
              title: '学习资源列表'
            }

          ]
        },
        {
          icon: 'el-icon-pie-chart',
          index: '6',
          title: '软件管理',
          subs: [
            {
              index: '/back/add_software',
              title: '添加软件'
            },
            {
              index: '/back/software_manage',
              title: '软件列表'
            }

          ]
        },
        {
          icon: 'el-icon-pie-chart',
          index: '/back/feedback_manage',
          title: '问题反馈'
        }

        // {
        //   icon: 'el-icon-pie-chart',
        //   index: '/backmanage/table',
        //   title: '基础表格'
        // },
        // {
        //   icon: 'el-icon-pie-chart',
        //   index: '/backmanage/tabs',
        //   title: 'tab选项卡'
        // },
        // {
        //   icon: 'el-icon-pie-chart',
        //   index: '3',
        //   title: '表单相关',
        //   subs: [
        //     {
        //       index: '/backmanage/form',
        //       title: '基本表单'
        //     },
        //     {
        //       index: '3-2',
        //       title: '三级菜单',
        //       subs: [
        //         {
        //           index: '/backmanage/editor',
        //           title: '富文本编辑器'
        //         },
        //         {
        //           index: 'markdown',
        //           title: 'markdown编辑器'
        //         }
        //       ]
        //     },
        //     {
        //       index: '/backmanage/upload',
        //       title: '文件上传'
        //     }
        //   ]
        // },
        // {
        //   icon: 'el-icon-pie-chart',
        //   index: '/backmanage/icon',
        //   title: '自定义图标'
        // },
        // {
        //   icon: 'el-icon-pie-chart',
        //   index: '/backmanage/charts',
        //   title: 'schart图表'
        // },
        // {
        //   icon: 'el-icon-rank',
        //   index: '6',
        //   title: '拖拽组件',
        //   subs: [
        //     {
        //       index: '/backmanage/drag',
        //       title: '拖拽列表'
        //     },
        //     {
        //       index: 'dialog',
        //       title: '拖拽弹框'
        //     }
        //   ]
        // },
        // {
        //   icon: 'el-icon-pie-chart',
        //   index: 'i18n',
        //   title: '国际化功能'
        // },
        // {
        //   icon: 'el-icon-pie-chart',
        //   index: '7',
        //   title: '错误处理',
        //   subs: [
        //     {
        //       index: 'permission',
        //       title: '权限测试'
        //     },
        //     {
        //       index: '404',
        //       title: '404页面'
        //     }
        //   ]
        // },
        // {
        //   icon: 'el-icon-pie-chart',
        //   index: '/donate',
        //   title: '支持作者'
        // }
      ]
    }
  },
  computed: {
    onRoutes () {
      return this.$route.path.replace('/', '')
    }
  },
  created () {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', msg => {
      this.collapse = msg
      bus.$emit('collapse-content', msg)
    })
  }
}
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}
.sidebar > ul {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/Sidebar.vue